import BaseService from "@/boot/BaseService";
class ClienteService extends BaseService {
    constructor() {
        super(null, "/clientes");
    }
    async list(searchTerm) {
        return await this.get("/list", { searchTerm });
    }

    async update(id, formData) {
        return await this.put(`/${id}`, formData);
    }

    async store(formData) {
        return await this.post("", formData);
    }

    async show(id) {
        return await this.get(`/${id}`);
    }
}

export default new ClienteService();
